<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <saa-s-child-page-container
    :loading="!loading"
    :use-return="true"
    @back="back"
  >
    <template #title>
      <div class="text-h3">
        {{ $t('NeedAdditionalHardware') }}
      </div>
    </template>

    <div
      v-dragscroll
      class="mt-8"
      style="overflow-x: scroll;"
    >
      <div
        style="display: grid;grid-auto-flow:column;grid-auto-columns: 160px;grid-gap: 24px;width: fit-content"
      >
        <v-card
          v-for="item in hardwareProductList"
          :key="item.id"
          class="pa-2 px-4"
          elevation="0"
          @click="showDetailDialog(item)"
        >
          <v-responsive :aspect-ratio="3/4">
            <div class=" d-flex flex-column align-center text-center">
              <v-img
                :src="item.images[0]"
                aspect-ratio="1"
                class="mt-4"
                width="70%"
              />
              <div class="mt-4">
                <div class="text-body-1 font-weight-medium">
                  {{ item.name }}
                </div>
                <div class="text-caption text--secondary">
                  {{ item.prices[0].unit_amount / 100 | priceDisplay }}
                </div>
              </div>
              <div class="mt-4 d-flex align-center">
                <v-icon @click.stop="changeCountForItem(item,-1)">
                  mdi-minus-circle
                </v-icon>
                <div class="text-body-2 mx-2 mt-n1">
                  {{ item.count }}
                </div>
                <v-icon
                  @click.stop="changeCountForItem(item,1)"
                >
                  mdi-plus-circle
                </v-icon>
              </div>
            </div>
          </v-responsive>
        </v-card>
      </div>
    </div>
    <template #actions>
      <next-step-button
        class="btnContentSelect"
        @next="next(true)"
      >
        <div class="d-block overflow-hidden">
          <div class="d-flex justify-center align-center">
            <template v-if="totalCount>0">
              <div
                class="text-truncate"
                style="position:relative;"
              >
                {{ $t('PurchaseSelectedHardware') }}
              </div>
              <div class="ml-1 text-no-wrap">
                {{ totalPrice| priceDisplay }}
              </div>
            </template>
            <template v-else>
              {{ $t('NotRequired') }}
            </template>
          </div>
        </div>
      </next-step-button>
    </template>
  </saa-s-child-page-container>
</template>

<script>
import NextStepButton from '@/views/SaaS/widget/NextStepButton.vue'
import SaaSChildPageContainer from '@/views/SaaS/widget/SaaSChildPageContainer.vue'
import { loadProducts, ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import { addProduct, getCurrentSaaSOrderInfo, removeProduct } from '@/views/SaaS/SaaSGuide'
import { mapMutations } from 'vuex'
import { keyBy } from 'lodash'
import { dragscroll } from 'vue-dragscroll/src/main'

export default {
  name: 'SelectHardware',
  components: {

    SaaSChildPageContainer,
    NextStepButton

  },
  directives: {
    dragscroll
  },
  data: function () {
    return {
      SaaSOrderInfo: [],
      selectedProductDetail: [],
      loading: false,
      hardwareProductList: [],
      allSelectItem: [],
      shouldShowCode: []
    }
  },
  computed: {
    totalCount () {
      return this.selectedProductList.reduce(
        (sum, i) => sum + i.count, 0)
    },
    selectedProductList () {
      return this.hardwareProductList.filter(it => it.count > 0)
    },
    totalPrice () {
      return this.selectedProductList.reduce(
        (sum, i) => sum + i.count * i.prices.find(it => it.type === 'one_time').unit_amount / 100, 0)
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    ...mapMutations(['showProductDetail']),
    showDetailDialog (item) {
      this.showProductDetail({
        code: item.metadata.code,
        SaaSGuide: 1,
        callback: () => {
          this.reload()
        }
      })
    },
    async reload () {
      this.loading = false
      const allProducts = (await loadProducts()).filter(it => it.metadata.type === 'hardware')
      this.shouldShowCode = [ProductCodes.sSamsung, ProductCodes.hPhone, ProductCodes.sEpsonTmT30, ProductCodes.hStickerPrinter, ProductCodes.hWifiPrinter]
      this.SaaSOrderInfo = await getCurrentSaaSOrderInfo()
      if ([1, 2, 7].includes(this.SaaSOrderInfo.storeType)) {
        this.shouldShowCode.push(ProductCodes.hsunmi, ProductCodes.hCashBox)
      } else {
        this.shouldShowCode.push(ProductCodes.hd5)
      }
      this.hardwareProductList = allProducts.filter(it => this.shouldShowCode.includes(it.metadata.code))
      this.hardwareProductList.forEach(it => {
        this.$set(it, 'count', 0)
      })
      const hostHardwareDict = keyBy(getCurrentSaaSOrderInfo().selectedProductList, 'stripe_metadata_code')
      this.hardwareProductList.forEach(it => {
        if (hostHardwareDict[it.metadata.code]) {
          it.count = hostHardwareDict[it.metadata.code].count
        }
      })
      this.loading = true
    },
    changeCountForItem (item, mod) {
      let countAfter = 0
      const maxCount = item.metadata.maxCount ?? 1
      countAfter = parseInt(item.count) + parseInt(mod)
      console.log(countAfter)
      if (countAfter >= 0) {
        if (countAfter <= maxCount) {
          item.count = countAfter
        }
      }
    },
    back () {
      this.$router.push({ name: 'recommended' })
    },
    next () {
      this.SaaSOrderInfo.selectedProductList.forEach(it => {
        if (this.shouldShowCode.includes(it.metadata.code)) {
          removeProduct(it)
        }
      })
      this.selectedProductList.forEach(it => {
        addProduct(it)
      })
      this.$router.push({ name: 'service' })
    }
  }
}
</script>

<style scoped>

</style>
